package com.macrofocus.eflux.components

import mui.material.styles.Palette
import mui.material.styles.Theme
import mui.system.SxProps
import web.cssom.*

fun SxProps<Theme>.blurBackground(theme: Theme) {
    backgroundColor =
        if (theme.palette.unsafeCast<Palette>().mode == mui.material.PaletteMode.light) rgb(255, 255, 255, 0.7) else rgb(0, 0, 0, 0.6)
    backgroundImage = if (theme.palette.unsafeCast<Palette>().mode == mui.material.PaletteMode.light)
        linearGradient(
            stop(rgb(0, 0, 0, 0.08), 0.pct),
            stop(rgb(0, 0, 0, 0.01), 100.pct)
        )
    else
        linearGradient(
            stop(rgb(255, 255, 255, 0.08), 0.pct),
            stop(rgb(255, 255, 255, 0.01), 100.pct)
        )
//                    box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 5px -1px, rgba(0, 0, 0, 0.14) 0px 6px 10px 0px, rgba(0, 0, 0, 0.12) 0px 1px 18px 0px;
    boxShadow = if (theme.palette.unsafeCast<Palette>().mode == mui.material.PaletteMode.light)
        BoxShadow(0.px, 3.px, 5.px, -1.px, rgb(0, 0, 0, 0.2))
    else
        BoxShadow(0.px, 3.px, 5.px, -1.px, rgb(255, 255, 255, 0.05))
    backdropFilter = blur(4.px)
    pointerEvents = PointerEvents.all
}
